import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hasPartner", "partnerDetails", "sameAddress", "addressDetails"]
  static values = {
    hasPartner: String,
    sameAddress: Boolean
  }

  connect() {
    // NOTE: I don't believe we need this. We have hidden set on the DOM elements and setting required to false in the togglePartnerDetails. If testing goes well, we can remove this.
    // Initially hide partner details and address details
    // this.partnerDetailsTarget.classList.add("hidden")
    // this.addressDetailsTarget.classList.add("hidden")
    
    // Disable all partner fields initially
    // this.partnerDetailsTarget.querySelectorAll("input, select").forEach(field => {
    //   field.disabled = true
    //   field.required = false
    // })
    // END NOTE:

    // // Set initial values and show/hide fields accordingly
    if (this.hasPartnerValue) {
      console.log("hasPartnerValue", this.hasPartnerValue)
      this.togglePartnerDetails()

      if (this.hasPartnerValue === "partner_yes" && this.sameAddressValue !== undefined) {
        this.sameAddressTarget.value = this.sameAddressValue.toString()
        this.toggleAddressDetails()
      }
    }
  }

  hasPartnerValueChanged() {
    this.togglePartnerDetails()
  }

  sameAddressValueChanged() {
    this.toggleAddressDetails()
  }

  togglePartnerDetails() {
    if (this.hasPartnerValue === "partner_yes") {
      this.partnerDetailsTarget.classList.remove("hidden")
      // Enable basic partner fields
      this.partnerDetailsTarget.querySelectorAll("input:not([name*='insurance_information']):not([name*='last_four_ssn']):not([name*='id_document']), select:not([name*='insurance_information'])").forEach(field => {
        field.disabled = false
        field.required = true
        field.classList.remove("border-red-500")
        field.removeAttribute("aria-invalid")
      })
      // Enable optional fields (insurance, SSN and ID document)
      this.partnerDetailsTarget.querySelectorAll("[name*='insurance_information'], [name*='last_four_ssn'], [name*='id_document'], [name*='partner[insurance_information_attributes][provider_phone]'], [name*='partner[address_attributes][street_address2]']").forEach(field => {
        field.disabled = false
        field.required = false
        field.classList.remove("border-red-500")
        field.removeAttribute("aria-invalid")
      })
    } else {
      this.partnerDetailsTarget.classList.add("hidden")
      if (this.hasPartnerValue !== "partner_not_answered") {
        this.hasPartnerTarget.value = this.hasPartnerValue
      }

      this.partnerDetailsTarget.querySelectorAll("input, select").forEach(field => {
        field.disabled = true
        field.required = false
        field.classList.remove("border-red-500")
        field.removeAttribute("aria-invalid")
      })
    }
  }

  toggleAddressDetails() {
    const sameAddress = this.sameAddressValue === true || this.sameAddressValue === "true";
    if (this.hasPartnerValue === "partner_yes" && !sameAddress) {
      this.addressDetailsTarget.classList.remove("hidden")
      this.addressDetailsTarget.querySelectorAll("input, select").forEach(field => {
        field.disabled = false
        field.required = true
        field.classList.remove("border-red-500")
        field.removeAttribute("aria-invalid")

        if (field.name.includes("country") && !field.value) {
          field.value = "US"
          field.dispatchEvent(new Event("change"))
        }
      })

      this.addressDetailsTarget.querySelectorAll("[name*='partner[address_attributes][street_address2]']").forEach(field => {
        field.disabled = false
        field.required = false
        field.classList.remove("border-red-500")
        field.removeAttribute("aria-invalid")
      })
    } else {
      this.addressDetailsTarget.classList.add("hidden")
      this.addressDetailsTarget.querySelectorAll("input, select").forEach(field => {
        field.disabled = true
        field.required = false
        field.classList.remove("border-red-500")
        field.removeAttribute("aria-invalid")
        field.value = ""
      })
    }
  }

  updateHasPartner() {
    this.hasPartnerValue = this.hasPartnerTarget.value
  }

  updateSameAddress() {
    this.sameAddressValue = this.sameAddressTarget.value === "true"
    this.toggleAddressDetails()
  }
} 